var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    [
      _c(
        "el-dialog",
        {
          staticClass: "pop-dialog pop-goods-info",
          attrs: {
            title: "商品信息",
            visible: _vm.visibleDialog,
            width: "920px",
            top: "calc(50vh - 220px)",
            "append-to-body": "",
          },
          on: {
            "update:visible": function ($event) {
              _vm.visibleDialog = $event
            },
          },
        },
        [
          _c(
            "div",
            {
              directives: [
                {
                  name: "loading",
                  rawName: "v-loading",
                  value: _vm.loading,
                  expression: "loading",
                },
              ],
              staticClass: "goods-con",
            },
            [
              _c(
                "el-table",
                { attrs: { data: _vm.tableData.items, height: "300px" } },
                [
                  _c("el-table-column", {
                    attrs: { label: "商品" },
                    scopedSlots: _vm._u([
                      {
                        key: "default",
                        fn: function (scope) {
                          return [
                            _c("div", { staticClass: "goods-info" }, [
                              _c(
                                "div",
                                { staticClass: "img" },
                                [
                                  _c(
                                    "el-image",
                                    {
                                      staticClass: "pic",
                                      attrs: {
                                        src:
                                          scope.row.goodsSkuPic ||
                                          scope.row.goodsPic,
                                        fit: "cover",
                                      },
                                    },
                                    [
                                      _c(
                                        "div",
                                        {
                                          staticClass: "image-slot",
                                          attrs: { slot: "error" },
                                          slot: "error",
                                        },
                                        [
                                          _c("i", {
                                            staticClass:
                                              "el-icon-picture-outline",
                                          }),
                                        ]
                                      ),
                                    ]
                                  ),
                                ],
                                1
                              ),
                              _c("div", { staticClass: "con" }, [
                                _c("div", { staticClass: "name" }, [
                                  _vm._v(
                                    "五域商品名称:" +
                                      _vm._s(
                                        scope.row.goodsName ||
                                          scope.row.wuyuGoodsName
                                      )
                                  ),
                                ]),
                                _c("div", { staticClass: "name" }, [
                                  _vm._v(
                                    "五域商品规格:" +
                                      _vm._s(
                                        scope.row.goodsSkuName ||
                                          scope.row.wuyuGoodsSpec
                                      )
                                  ),
                                ]),
                                _c("div", { staticClass: "name" }, [
                                  _vm._v("体积：" + _vm._s(scope.row.volume)),
                                  _c("span", { staticClass: "space" }),
                                  _vm._v("重量：" + _vm._s(scope.row.weight)),
                                ]),
                                _c("div", { staticClass: "text space-top" }, [
                                  _vm._v(
                                    "店铺商品名称:" +
                                      _vm._s(scope.row.shopGoodsName)
                                  ),
                                ]),
                                _c("div", { staticClass: "text" }, [
                                  _vm._v(
                                    "店铺商品规格:" +
                                      _vm._s(scope.row.shopGoodsSpec)
                                  ),
                                ]),
                              ]),
                            ]),
                          ]
                        },
                      },
                    ]),
                  }),
                  _c("el-table-column", {
                    attrs: { label: "编号", width: "190" },
                    scopedSlots: _vm._u([
                      {
                        key: "default",
                        fn: function (scope) {
                          return [
                            _c("div", { staticClass: "name" }, [
                              _vm._v(
                                "商品编号：" +
                                  _vm._s(
                                    scope.row.wyGoodsCode ||
                                      scope.row.wuyuGoodsCode ||
                                      "缺失"
                                  )
                              ),
                            ]),
                            _c("div", { staticClass: "name" }, [
                              _vm._v(
                                "商品规格编号：" +
                                  _vm._s(scope.row.wuyuSku || "缺失")
                              ),
                            ]),
                            _c("div", { staticClass: "text" }, [
                              _vm._v(
                                "外部编号：" +
                                  _vm._s(scope.row.outGoodsCode || "缺失")
                              ),
                            ]),
                          ]
                        },
                      },
                    ]),
                  }),
                  _vm.type === "edit"
                    ? _c("el-table-column", {
                        attrs: { label: "操作", width: "80" },
                        scopedSlots: _vm._u(
                          [
                            {
                              key: "default",
                              fn: function (scope) {
                                return [
                                  _c(
                                    "div",
                                    {
                                      staticClass: "primary hand",
                                      on: {
                                        click: function ($event) {
                                          return _vm.onEdit(scope.row)
                                        },
                                      },
                                    },
                                    [_vm._v("编辑")]
                                  ),
                                ]
                              },
                            },
                          ],
                          null,
                          false,
                          4103768482
                        ),
                      })
                    : _vm._e(),
                  _c("el-table-column", {
                    attrs: { label: "价格", width: "80" },
                    scopedSlots: _vm._u([
                      {
                        key: "default",
                        fn: function (scope) {
                          return [
                            _c("div", { staticClass: "name" }, [
                              _vm._v("￥" + _vm._s(scope.row.goodsPrice)),
                            ]),
                          ]
                        },
                      },
                    ]),
                  }),
                  _c("el-table-column", {
                    attrs: { label: "数量", width: "80" },
                    scopedSlots: _vm._u([
                      {
                        key: "default",
                        fn: function (scope) {
                          return [
                            _c("div", { staticClass: "name" }, [
                              _vm._v("*" + _vm._s(scope.row.quantity)),
                            ]),
                          ]
                        },
                      },
                    ]),
                  }),
                ],
                1
              ),
              _vm.type === "edit"
                ? _c("div", { staticClass: "total-con" }, [
                    _vm._v(" 总计： "),
                    _c("div", { staticClass: "space-row" }, [
                      _vm._v("￥" + _vm._s(_vm.tableData.totalGoodsAmount)),
                    ]),
                    _c("div", { staticClass: "space-row" }, [
                      _vm._v("*" + _vm._s(_vm.tableData.totalItemCount)),
                    ]),
                  ])
                : _c("div", { staticClass: "total-con" }, [
                    _vm._v(
                      " 总计：共" + _vm._s(_vm.tableData.totalItemCount) + "件 "
                    ),
                    _c("div", { staticClass: "space" }, [
                      _vm._v(
                        "商品总价：￥" + _vm._s(_vm.tableData.totalGoodsAmount)
                      ),
                    ]),
                    _c("div", { staticClass: "space" }, [
                      _vm._v(
                        "运费：￥" + _vm._s(_vm.tableData.totalFreightAmount)
                      ),
                    ]),
                    _c("div", { staticClass: "space" }, [
                      _vm._v(
                        "应付：￥" + _vm._s(_vm.tableData.receivableAmount)
                      ),
                    ]),
                    _c("div", { staticClass: "space" }, [
                      _vm._v("已付：￥" + _vm._s(_vm.tableData.paidAmount)),
                    ]),
                  ]),
            ],
            1
          ),
        ]
      ),
      _c(
        "el-dialog",
        {
          staticClass: "pop-dialog pop-goods-edit",
          attrs: {
            title: "录入/编辑商品编码",
            visible: _vm.eidtDialog,
            width: "410px",
            top: "calc(50vh - 90px)",
            "append-to-body": "",
          },
          on: {
            "update:visible": function ($event) {
              _vm.eidtDialog = $event
            },
          },
        },
        [
          _c(
            "el-form",
            {
              ref: "form",
              staticClass: "edit-con",
              attrs: {
                model: _vm.form,
                rules: _vm.rules,
                "label-width": "120px",
                size: "mini",
              },
            },
            [
              _c(
                "el-form-item",
                { attrs: { label: "商品规格编号", prop: "wyGoodsCode" } },
                [
                  _c("el-input", {
                    attrs: { placeholder: "请输入商品规格编号" },
                    model: {
                      value: _vm.form.wyGoodsCode,
                      callback: function ($$v) {
                        _vm.$set(_vm.form, "wyGoodsCode", $$v)
                      },
                      expression: "form.wyGoodsCode",
                    },
                  }),
                ],
                1
              ),
            ],
            1
          ),
          _c(
            "template",
            { slot: "footer" },
            [
              _c(
                "el-button",
                {
                  attrs: { size: "mini" },
                  on: {
                    click: function ($event) {
                      _vm.eidtDialog = false
                    },
                  },
                },
                [_vm._v("取 消")]
              ),
              _c(
                "el-button",
                {
                  attrs: {
                    type: "primary",
                    size: "mini",
                    loading: _vm.loading,
                  },
                  on: { click: _vm.onConfirm },
                },
                [_vm._v("确 定")]
              ),
            ],
            1
          ),
        ],
        2
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }